/**
 * @generated SignedSource<<b3b2d7a2206f414b1017420c6c4f00c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SCHEDULED";
export type WorkspaceSignalEditMainSubscription$variables = {
  signalWorkspaceId: string;
  workspaceId: string;
};
export type WorkspaceSignalEditMainSubscription$data = {
  readonly signalWorkspaceChanged: {
    readonly id: string;
    readonly signalCount: number;
    readonly status: WorkspaceSignalStatus;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRecieversListItemButton_workspaceEntity" | "WorkspaceSignalEditMainContent_Signal" | "WorkspaceSignalEditMainEditedInfo_Signal" | "WorkspaceSignalEditMainPrioritySelector_Signal" | "WorkspaceSignalEditMainProducts_Signal" | "WorkspaceSignalEditMainPushNotification_signalWorkspace">;
  } | null;
};
export type WorkspaceSignalEditMainSubscription = {
  response: WorkspaceSignalEditMainSubscription$data;
  variables: WorkspaceSignalEditMainSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "signalWorkspaceId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v2 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "signalWorkspaceIds.0",
        "variableName": "signalWorkspaceId"
      }
    ],
    "kind": "ListValue",
    "name": "signalWorkspaceIds"
  },
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signalCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  (v6/*: any*/),
  (v3/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlExpiresAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbhash",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalEditMainSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SignalWorkspace",
        "kind": "LinkedField",
        "name": "signalWorkspaceChanged",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceSignalEditMainPrioritySelector_Signal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceSignalEditMainEditedInfo_Signal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceSignalEditMainContent_Signal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceSignalEditMainProducts_Signal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceSignalEditMainPushNotification_signalWorkspace"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceRecieversListItemButton_workspaceEntity"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceSignalEditMainSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SignalWorkspace",
        "kind": "LinkedField",
        "name": "signalWorkspaceChanged",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priority",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "updatedAtDate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isoString",
                "storageKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isDate"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formattedBody",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedBySessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "descriptionImages",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageSize",
                "kind": "LinkedField",
                "name": "sizes",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v3/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "descriptionFiles",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v10/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOrg",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FilePage",
                "kind": "LinkedField",
                "name": "pages",
                "plural": true,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "thumbnail",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageSize",
                    "kind": "LinkedField",
                    "name": "sizes",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceProduct",
            "kind": "LinkedField",
            "name": "linkedProducts",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "partNumber",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sendNotificationAtPublish",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReceiverStore",
                "kind": "LinkedField",
                "name": "potentialReceiverStores",
                "plural": true,
                "selections": (v13/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "receiverStores",
                "plural": true,
                "selections": (v13/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OrgTopic",
                "kind": "LinkedField",
                "name": "topic",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "type": "WorkspaceEntity",
            "abstractKey": "__isWorkspaceEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "13c1a0ba2b015ba7fb76ac98a577211e",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalEditMainSubscription",
    "operationKind": "subscription",
    "text": "subscription WorkspaceSignalEditMainSubscription(\n  $workspaceId: ID!\n  $signalWorkspaceId: ID!\n) {\n  signalWorkspaceChanged(signalWorkspaceIds: [$signalWorkspaceId], workspaceId: $workspaceId) {\n    id\n    status\n    signalCount\n    ...WorkspaceSignalEditMainPrioritySelector_Signal\n    ...WorkspaceSignalEditMainEditedInfo_Signal\n    ...WorkspaceSignalEditMainContent_Signal\n    ...WorkspaceSignalEditMainProducts_Signal\n    ...WorkspaceSignalEditMainPushNotification_signalWorkspace\n    ...WorkspaceRecieversListItemButton_workspaceEntity\n  }\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment LinkedContentInput_files on File {\n  ...LinkedContent_files\n}\n\nfragment LinkedContentInput_images on Image {\n  ...LinkedContent_images\n}\n\nfragment LinkedContent_files on File {\n  id\n  name\n  type\n  url\n  ...LinkedFileItem_file\n}\n\nfragment LinkedContent_images on Image {\n  id\n  sizes {\n    height\n    width\n    id\n  }\n  ...Image_image\n  ...LinkedImageItem_image\n}\n\nfragment LinkedFileItem_file on File {\n  id\n  name\n  ...FileIcon_File\n  pages {\n    id\n  }\n  thumbnail {\n    id\n    ...Image_image\n  }\n}\n\nfragment LinkedImageItem_image on Image {\n  id\n  ...Image_image\n}\n\nfragment LinkedWorkspaceProductItem_WorkspaceProduct on WorkspaceProduct {\n  id\n  imageUrl\n  partNumber\n  name\n}\n\nfragment WorkspaceRecieversListItemButton_workspaceEntity on WorkspaceEntity {\n  __isWorkspaceEntity: __typename\n  potentialReceiverStores {\n    __typename\n    id\n  }\n  receiverStores {\n    __typename\n    id\n  }\n  topic {\n    name\n    id\n  }\n}\n\nfragment WorkspaceSignalEditMainContent_Signal on SignalWorkspace {\n  id\n  title\n  body\n  formattedBody\n  updatedBySessionId\n  ...WorkspaceSignalLinkedContent_signal\n}\n\nfragment WorkspaceSignalEditMainEditedInfo_Signal on SignalWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment WorkspaceSignalEditMainPrioritySelector_Signal on SignalWorkspace {\n  id\n  priority\n  updatedAtDate {\n    ...FormattedDate\n    isoString\n  }\n  updatedBy {\n    name\n    id\n  }\n}\n\nfragment WorkspaceSignalEditMainProducts_Signal on SignalWorkspace {\n  id\n  linkedProducts {\n    id\n    ...LinkedWorkspaceProductItem_WorkspaceProduct\n  }\n}\n\nfragment WorkspaceSignalEditMainPushNotification_signalWorkspace on SignalWorkspace {\n  id\n  sendNotificationAtPublish\n  updatedAtDate {\n    isoString\n    ...FormattedDate\n  }\n  updatedBy {\n    name\n    id\n  }\n}\n\nfragment WorkspaceSignalLinkedContent_signal on SignalWorkspace {\n  id\n  descriptionImages {\n    id\n    ...LinkedContentInput_images\n  }\n  descriptionFiles {\n    id\n    url\n    name\n    type\n    ...LinkedContentInput_files\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "dcb9596bae137189428b595ecd64cad8";

export default node;
